import { createRouter, createWebHistory } from 'vue-router';
// import { useAuthStore } from '@/stores/authStore';

import Dashboard from '@/views/DashboardView.vue';

import Einstellungen from '@/views/EinstellungenView.vue';

import Unternehmen from '../views/Unternehmen/UnternehmenView.vue';
import UnternehmenDetails from '@/views/Unternehmen/UnternehmenDetailsView.vue';

import Applications from '../views/Applications/ApplicationsView.vue';
import ApplicationDetails from '../views/Applications/ApplicationDetailsView.vue';

import Benutzer from '@/views/Benutzer/BenutzerView.vue';
import BenutzerDetails from '@/views/Benutzer/BenutzerDetailsView.vue';

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
  },

  {
    path: '/applications',
    name: 'Applications',
    component: Applications,
  },

  {
    path: '/application/:id',
    name: 'ApplicationDetails',
    component: ApplicationDetails,
    props: (route: any) => ({
      id: parseInt(route.params.id as string),
    }),
  },

  {
    path: '/benutzer',
    name: 'Benutzer',
    component: Benutzer,
  },

  {
    path: '/benutzer/:id',
    name: 'BenutzerDetails',
    component: BenutzerDetails,
    props: (route: any) => ({
      id: route.params.id as string,
      realm: route.query.realm as string,
    }),
  },

  {
    path: '/unternehmen',
    name: 'Unternehmen',
    component: Unternehmen,
  },
  {
    path: '/unternehmen/:id',
    name: 'UnternehmenDetails',
    component: UnternehmenDetails,
    props: (route: any) => ({
      id: parseInt(route.params.id as string),
    }),
  },

  {
    path: '/settings',
    name: 'Einstellungen',
    component: Einstellungen,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((_to, _from) => {
//   const auth = useAuthStore();

//   console.log(JSON.parse(JSON.stringify(auth.kc)));
//   console.log('🔐 guard → initialized:', auth.kc.didInitialize, 'isAuthenticated:', auth.kc.authenticated);

//   console.log("ISAUTHENTICATED:", auth.isAuthenticated);

// if (!auth.kc.authenticated) {
//   console.log("route guard: LOGIN");
//   // auth.login();

//   return false; // Prevent navigation
// }
// });

export default router;
